module.exports = __webpack_public_path__ + "static/media/list-item-placeholder.590408bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/list-item-placeholder.png
// module id = 528
// module chunks = 0